<cmn-header></cmn-header>
<div class="sizingContainer" role="main">
    <div class="content">
        <div>
            <div id="contentControllerId" >
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
<cmn-footer></cmn-footer>